import { memo } from 'react';
import PortalIdParser from 'PortalIdParser';
import { getFileExtensionFromReference } from './utils';
import { FileTypeIcon } from 'file-manager-components/components/FileTypeIcon';
import FileItemLayout from './components/FileItemLayout';
import FileLink from './FileLink';
import { jsx as _jsx } from "react/jsx-runtime";
const ResolvedFileItem = ({
  fileReference,
  variant = 'default',
  actions
}) => {
  const portalId = PortalIdParser.get();
  if (!portalId) {
    return null;
  }
  return /*#__PURE__*/_jsx(FileItemLayout, {
    variant: variant,
    icon: /*#__PURE__*/_jsx(FileTypeIcon, {
      fileType: fileReference.additionalProperties.type,
      extension: getFileExtensionFromReference(fileReference),
      size: "400"
    }),
    labelContent: /*#__PURE__*/_jsx(FileLink, {
      fileReference: fileReference,
      portalId: portalId
    }),
    actions: actions
  });
};
export default /*#__PURE__*/memo(ResolvedFileItem);